import PARENT from '../types';

export const SET_BINOMIAL_ALPHA = `${PARENT}/SET_BINOMIAL_ALPHA`;
